module.exports = __webpack_public_path__ + "static/img/profile-img.ba4e037e.png";